import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Tooltip } from '@mui/material';
import { Order } from 'models/order';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

type IconAreaNotificationsIconProps = {
    order: Order;
};
const IconAreaNotificationsIcon: FC<IconAreaNotificationsIconProps> = ({ order }: IconAreaNotificationsIconProps) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Fragment>
            {order.unreadMessagesCount > 0 ? (
                <Tooltip title={<span>{translate('orders:UNREAD_MESSAGES')}</span>}>
                    <Badge badgeContent={order.unreadMessagesCount} color="info">
                        <NotificationsIcon sx={{ color: '#f4b400' }} />
                    </Badge>
                </Tooltip>
            ) : (
                <Tooltip title={<span>{translate('orders:NO_UNREAD_MESSAGES')}</span>}>
                    <NotificationsNoneIcon sx={{ color: '#f2f2f2' }} />
                </Tooltip>
            )}
        </Fragment>
    );
};

export default IconAreaNotificationsIcon;
